import commonGetters from '@/store/data/common/getters'
import { find, isNil } from 'lodash'

const getters = {
    ...commonGetters,
    getActiveItemByJsonKeyName: state => params => {
        const item = find(state.activeList[params.provider].list, item => item.jsonKey.name === params.jsonKeyName)
        return isNil(item) ? {} : item
    }
}

export default getters
